import React, { useContext } from 'react';

//material ui
import { makeStyles } from '@material-ui/core/styles';

//helper functions
import {
  wcsLogin,
  wcsRegister,
  connectToSelfHostedWeaviate,
} from '../../helperFunctions';

//global state
import { StateContext, StateDispatchContext } from '../../AppStateContext';

//to use browser history
import { useHistory } from 'react-router-dom';

//components
import LoginFormContent from './LoginFormContent';

//styling
import '../../Styles/StartPage.scss';

const useStyles = makeStyles((theme) => ({
  outer: {
    width: '470px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#1a2461',
    borderRadius: '1rem',
    padding: '1rem',
    color: '#fff',
    '@media (max-width: 450px)': {
      width: '340px',
    },
  },

  header: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  },

  typography: {
    fontFamily: '"Alegreya Sans", sans-serif',
  },

  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  wcs: {
    marginBottom: theme.spacing(2),
  },
  links: {
    cursor: 'pointer',
    fontFamily: '"Alegreya Sans", sans-serif',
    color: '#fa0171 !important',
    fontSize: '17px',
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
    width: '180px',
  },
  selfHostedWeaviate: {
    height: '130px',
    marginTop: theme.spacing(2),
  },
  bottomText: {
    fontFamily: '"Alegreya Sans", sans-serif',
    fontSize: '15px',
    margin: '0',
    lineHeight: '23px',
  },
}));

export default function LoginForm() {
  const classes = useStyles();

  //to consume global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  //to consume browser history
  const history = useHistory();

  const handleWscLogin = (e) => {
    e.preventDefault();

    wcsLogin(setState, state);
  };

  const handleWcsRegister = (e) => {
    e.preventDefault();

    wcsRegister(setState, state);
  };

  const handleChange = (e) => {
    setState({
      ...state,
      connectToWeaviateURI: e.target.value.replace(/ /g, ''),
    });
  };

  //This function handles connecting to self hosted weaviate. Throws an error message if failed
  const handleClick = async (e) => {
    e.preventDefault();
    setState({ ...state, isLoginLoading: true });

    connectToSelfHostedWeaviate(history, setState, state);
  };

  return (
    <LoginFormContent
      handleWscLogin={handleWscLogin}
      handleWcsRegister={handleWcsRegister}
      handleChange={handleChange}
      handleClick={handleClick}
      classes={classes}
    />
  );
}
